import PagedElements from "./pagedelements";
import AccountingGetPurchaseListViewModel from "../view/accountinggetpurchaselistviewmodel";

export default class PagedAccountingGetPurchases extends PagedElements<AccountingGetPurchaseListViewModel> {
    constructor(init?: Partial<PagedAccountingGetPurchases>) { super(init); }
}